import React from 'react';

const icDelete = (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M9 2.4C9 1.47 9 0.876 9 0H3C3 0.876 3 1.47 3 2.4C1.872 2.4 1.122 2.4 0 2.4V3.6H1.8V12C5.226 12 6.186 12 10.2 12V3.6H12V2.4C10.134 2.4 10.602 2.4 9 2.4ZM4.2 1.2H7.8V2.4H4.2V1.2ZM9 10.8H3V3.6H9V10.8ZM7.8 9.6H6.6V4.8H7.8V9.6ZM5.4 9.6H4.2V4.8H5.4V9.6Z'
            fill='#212121'
        />
    </svg>
);

export default icDelete;
